import { gerarDadosBoleto } from './gerarDadosBoleto';
import { gerarRemessa } from './gerarRemessa';
import { gerarPDF } from './gerarPDF';
import { gerarRetorno } from './gerarRetorno';

export const sicoob = {
  gerarDadosBoleto,
  gerarRemessa,
  gerarPDF,
  gerarRetorno,
};
